import request from '@/router/axios'

const urlPrefix = '/sys'

// 薪酬数据驾驶舱-三个看板
export function getAllBudgetByYear(data) {
  return request({
    url: urlPrefix + '/cofcodata/getAllBudgetByYear',
    method: 'post',
    data
  })
}

// 预算执行情况（柱状图）
export function getMonthLaborCostByMonth(data) {
  return request({
    url: urlPrefix + '/cofcodata/getMonthLaborCostByMonth',
    method: 'post',
    data
  })
}

// 预算执行率&同比增福（折线图）
export function getMonthLaborCost(data) {
  return request({
    url: urlPrefix + '/cofcodata/getMonthLaborCost',
    method: 'post',
    data
  })
}
// 各部门情况
export function getDeptMonthLaborCostByYear(data) {
  return request({
    url: urlPrefix + '/cofcodata/getDeptMonthLaborCostByYear',
    method: 'post',
    data
  })
}
// 员工薪酬水平
export function getEmployeeSalaryLevelDistribution(data) {
  return request({
    url: urlPrefix + '/cofcodata/getEmployeeSalaryLevelDistribution',
    method: 'post',
    data
  })
}
